import React from "react";
import { StaticImage } from "gatsby-plugin-image"

const HomeBannerImage = () => {

    return (
        <StaticImage src="../../images/home_banner.jpg" layout="fullWidth" placeholder="blurred" formats={["webp"]} alt="banner" quality="65" className="img-fluid banner_img" />
    )

}

export default HomeBannerImage